<!-- 公开询价 enquiryType: 1 Enquiry/querySupplierOfferList-->
<template>
  <div>
    <Comment :query="{ enquiryType: 1 }" back="/openInquiry" />
  </div>
</template>

<script>
import Comment from './components/common.vue';
export default {
  name: 'OpenInquiry',
  components: { Comment },
};
</script>
<style lang="scss" scoped></style>
